<template>
    <div class="mx-auto px-4 py-4 sm:px-6 lg:px-6" id="scroll_comm">
        <h3 class="text-lg leading-6 font-medium">
            2022 & 2023 Commission Reports
        </h3>
        <div class="
          bg-white
          shadow
          overflow-hidden
          sm:rounded-lg
          shadow
          overflow-auto
          border-b border-gray-200
          sm:rounded-lg px-8 py-5 text-sm
        ">
        <p>
        <a class="text-sm Pmt-2 cobalt-text-color inline-flex border-b-2 border-blue-200 hover:border-blue-200 cursor-pointer" @click="$router.push('/commission_report')">Click here to access Commission Reports </a></p>
        
        <a class="pt-4 text-sm Pmt-2 cobalt-text-color inline-flex border-b-2 border-blue-200 hover:border-blue-200 cursor-pointer" id="accordion-label">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
</svg> 
        </a>
        <div class="overflow-hidden py-2 rounded-md p-4">
            <div class="accordion-content active bg-blue-50" id="accordion-content">
                <div class="px-4 py-3">
                    <p>
                This Commission Report can be viewed two ways:
                <ul class="list-disc px-5">
                    <li class="py-1">
                        By Company – Displays member count, paid amount, and commission amount totals for each company.
                    </li>
                    <li class="py-1">
                        By Company Members – Displays company, member name, plan name, paid amount, and commission amount for each member (if the member has multiple plans, this will be represented on multiple rows).
                    </li>
                </ul>
                Select a Year and Month, then click Search. 
                <span class="text-red-600 text-sm">
                    <p><b>Please note:</b> The Commission Report only displays companies that U.S. Legal received payment of premiums for during the selected month/year. If a company is not listed, U.S. Legal did not receive payment for that month/year. Should you have any questions, please contact us at (800) 356-LAWS.</p>
                    <p class="py-2">If Agent does not notify U.S. Legal of any errors, which would result in U.S. Legal owing Agent additional compensation, within 30 days of the issuance of the payment of compensation for which the payment covers, then it shall be conclusive that the payment amounts are accurate. If there are any monies due to Agent within the above referenced 30-day period, they will be paid at the time of the Agent’s next commissions check.</p>
                </span>
            </p>
                </div>
            </div>
        </div>
      
            </div>
        <div class="
          bg-white
          shadow
          overflow-hidden
          sm:rounded-lg
          shadow
          overflow-auto
          border-b border-gray-200
          sm:rounded-lg
        ">
        <form class="mt-5 sm:flex sm:items-center flex-wrap px-4">
        
            <div class="w-full flex items-center mb-2">
            <div class="w-full sm:max-w-md mb-2 sm:mb-0 mr-2">
                <AutoComplete class="h-10 pt-1 w-full" 
                placeholder="Search by Company"
                forceSelection :dropdown="true" v-model="search.company" :suggestions="companyList" 
                @complete="searchAutocomplete($event, 'company_list')" field="name" />
            </div>
            <div class="w-full sm:max-w-md mb-2 sm:mb-0 mr-2">
                <select class="h-10 form-select appearance-none block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Year select example" ref="selectedYear" v-model="search.selectedYear">
                <option value="" disabled>Select Year</option>
                </select>
            </div>

            <div class="w-full sm:max-w-md mb-2 sm:mb-0">
                <select class="h-10 form-select appearance-none block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Month select example" v-model="search.selectedMonth" ref="selectedMonth">
                <option value="" disabled>Select Month</option>
                </select>
            </div>
            <button class="mt-1 mr-2 relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 cobalt-button-color" type="button" @click="getReportData()">
                Search
            </button>

            <button class="mt-1 mr-2 relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 cobalt-button-color" v-if="data?.length > 0" type="button" @click="exportCSV($event)">
                Export
            </button>

            <button class="mt-2 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-400 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" type="button" @click="clearFilter()">
                Clear
            </button>
            </div>
            </form>

            <div class="mt-3 items-center px-8" v-if="totalAmount > 0 && totalComm > 0">
                <div>Total Premium Amount : ${{separator(totalAmount)}}</div>
                <div>Total Commission Amount: ${{separator(totalComm)}}</div>
            </div>
            <DataTable
            filterDisplay="row"
            ref="dt"
            :resizableColumns="true" columnResizeMode="expand"
              class="mt-5 min-w-full divide-y divide-gray-200 font-xs"
              :value="data"
              @page="onPageChange($event)"
            :totalRecords="totalRecords"
            :first="first"
            :lazy="lazyParams" :paginator="true"
              :alwaysShowPaginator="false"
              :rowsPerPageOptions=[5,10,20,50,70,100]
              :rows="10"
            >
              <template #empty>
                No Records Found
              </template>
              <ColumnGroup type="header">
                <row>
              <Column
             headerStyle="width: 70px"
            bodyStyle="width: 70px"
            v-for="column in columns"
            :key="column.title"
            :field="column.key"
            exportFilename="exportfilename"
            :header="column.title"
          >

          <template #body="slotProps" v-if="column.key == 'payment_amount' || column.key == 'comm_amt' || column.key == 'comm_rate' || column.key == 'plan_rate' || column.key=='comm_per'"
              ><span v-if="column.key == 'payment_amount'">${{ separator(slotProps?.data?.payment_amount) }}</span>
              <span v-if="column.key == 'comm_amt'">${{ separator(slotProps?.data?.comm_amt) }}</span>
              <span v-if="column.key == 'comm_rate'">${{ separator(slotProps?.data?.comm_rate) }}</span>
              <span v-if="column.key == 'plan_rate'">${{ separator(slotProps?.data?.plan_rate) }}</span>
              <span v-if="column.key == 'comm_per'">{{ separator(slotProps?.data?.comm_per) }}%</span></template
            >
          </Column>
          </row>
          </ColumnGroup>
        </DataTable>
        </div>
    </div>
</template>
  
<script>
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery"; // To use jquery
import Constants from "../constants.ts";
// import axios from "axios";
import { ref } from 'vue';
export default {
    data() {
        return {
            focusedInput: null,
            API_BASE: Constants.API_BASE,
            columns: [
                {
                    title: "Company Number",
                    key: "COMPNO",
                },
                {
                    title: "Company Name",
                    key: "COMPANY",
                },
                {
                    title: "Member Count",
                    key: "count_member",
                },
                {
                    title: "Premium Amount Received",
                    key: "payment_amount",
                },
                {
                    title: "Commission Amount",
                    key: "comm_amt",
                }
            ],
            search: {
                selectedYear: "",
                selectedMonth: "",
                flt_str: "",
            },
            first : ref(0),
            totalRecords :ref(0),
            lazyParams : ref({}),
            company_list:[],
            companyList:[],
            data: ref(0),
            totalAmount: 0,
            totalComm: 0,
            totalPremiumComm:0,
            config: {
                wrap: true,
                altFormat: "Y-m-d",
                altInput: true,
                dateFormat: "Y-m-d",
            },
        };
    },
    computed: mapState(["agent_user","token"]), // get central level variable from store
    mounted() {
        setTimeout(() => {
            document.getElementById('accordion-label').text="Click here to hide help/instructions.";
        }, 100);
        document.getElementById('accordion-label').addEventListener('click', function() {
            var content = document.getElementById('accordion-content');
            content.classList.toggle('active');
            if(document.getElementById('accordion-label').text=="Click here to hide help/instructions."){
                document.getElementById('accordion-label').text="For more help/Instructions, click here.";
            }else{
                document.getElementById('accordion-label').text="Click here to hide help/instructions.";
            }
        });


        const selectedYear = document.querySelector('select[aria-label="Year select example"]');
        const currentYear = 2023;
        const endYear = 2022;
        for (let year = currentYear; year >= endYear; year--) {
            const option = document.createElement('option');
            option.value = year;
            option.text = year;
            selectedYear.add(option);
        }
        const selectedMonth = document.querySelector('select[aria-label="Month select example"]');

        let endMonth=11;
        selectedMonth.innerHTML = '';
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.text = 'Select Month';
        defaultOption.disabled = true;
        selectedMonth.add(defaultOption);

        // Populate month options up to the end month
        for (let month = 0; month <= endMonth; month++) {
            const option = document.createElement('option');
            option.value = (month + 1).toString().padStart(2, '0'); // Month values are 1-indexed
            option.text = new Date(2000, month).toLocaleString('default', { month: 'long' });
            selectedMonth.add(option);
        }
        const currentDate = new Date();
        const previousMonth = currentDate.getMonth() === 0 ? 12 : currentDate.getMonth();
            this.search.selectedMonth = String(previousMonth).padStart(2, '0');
            this.search.selectedYear = 2023;
        this.getCompany();
        // this.getReportData();
        this.lazyParams.value = {
            first: 0,
            rows: 10,
        };
    },
    methods: {
        searchAutocomplete: function(event, field) {
            if (field == "company_list") {
                if (!event.query.trim().length) {
                this.companyList = [...this.company_list];
                } else {
                this.companyList = this.company_list.filter((item) => {
                    return item?.name
                    ?.toLowerCase()
                    .includes(event.query.toLowerCase());
                });
                }
                console.log(this.companyList)
            }
        },
        getCompany(){
            this.$http
                    .get(
                        `fetch_agent_company.php`,
                        {
                            headers: {
                                "Authorization": this.token,
                                "AgentSelected":this.agent_user.id
                            },
                        }
                    )
                    .then((response) => {
                        if (response?.data?.status == "unAuthorized") {
                                document.getElementById("loader").classList.add("hidden");
                                this.$toast.error(response.data.message);
                                this.$store.dispatch("logout");
                                this.$router.push("/login");
                            } else {
                            console.log(response);
                            this.company_list = response.data;
                        }
                    })
                    .catch((e) => {
                        this.$store.state.loader = false;
                        console.log("e", e);
                    });
        },
        onSort(event){
            console.log(event)
            this.lazyParams.value = event;
            this.getReportData(event);
        },
        onPageChange(event) {
        this.lazyParams.value = event;
        this.getReportData(event);
        $('html, body').animate({ scrollTop: 0 });
    },
        separator(numb) {
            if(numb!='' && numb!=null){
                var str = numb.toString().split(".");
                str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return str.join(".");
            }
        },
        exportCSV() {
            let filter_str = "?";
            if(this.search.company!="" && this.search.company!=undefined){
                console.log(this.search.company)
                filter_str += "company=" + this.search.company?.number;
            }
            if(this.search.selectedYear!="" && this.search.selectedYear!=undefined){
                filter_str += "&selectedYear=" + this.search.selectedYear;
                filter_str += "&selectedMonth=" + this.search.selectedMonth;
            }
            filter_str += "&report_name=old_commission_report";
            filter_str += "&act=" + encodeURIComponent(this.token);
            filter_str+="&agents="+this.agent_user.id;
            window.location.href = this.API_BASE + "export_to_csv.php" + filter_str;
        },
        clearFilter() {
            this.search.flt_str="";
           this.search.company="";
           this.search.member="";
           this.search.selectedYear="";
           this.search.selectedMonth="";
           this.data=[];
           this.totalAmount=0;
           this.totalRecords=0;
        },

        getReportData(event) {
            if(this.search.selectedYear!=""){
                if(this.search.selectedMonth=="" || this.search.selectedMonth==null){
                    this.$toast.error("Please select End date");
                    return false;
                }
            }
            if(this.search.selectedMonth!=""){
                if(this.search.selectedYear=="" || this.search.selectedYear==null){
                    this.$toast.error("Please select Start date");
                    return false;
                }
            }
            document.getElementById("loader").classList.remove("hidden");
            this.lazyParams.value = { ...this.lazyParams.value, first: event?.first || this.first };
                    let filter={'limit':10,'offset':0,'sortField':'COMPANY asc'};
                    if(event?.rows>0){
                        let order='asc';
                        if(event.sortOrder==-1){
                            order='desc';
                        }
                        if(event.sortField=='' || event.sortField==null){
                            event.sortField='COMPANY'; 
                        }
                        filter={'limit':event.rows,'offset':event.first,'sortField':event.sortField+' '+order};
                    }
                    
                    this.$http
                        .post(
                            `old_commission_report.php`,
                            {'search':this.search,"paginate":filter},
                            {
                                headers: {
                                    "Authorization": this.token,
                                    "AgentSelected":this.agent_user.id
                                },
                            }
                        )
                        .then((response) => {
                            this.$store.state.loader = false;
                            if (response?.data?.status == "unAuthorized") {
                                document.getElementById("loader").classList.add("hidden");
                                this.$toast.error(response.data.message);
                                this.$store.dispatch("logout");
                                this.$router.push("/login");
                            } else {
                                document.getElementById("loader").classList.add("hidden");
                                this.data = response.data.data;
                                this.totalRecords = response.data.totalRecords;
                                this.totalAmount=response.data.total_payment;
                                this.totalComm = response.data.total_comm;
                                setTimeout(() => {
                                    $('.p-datatable .p-datatable-tfoot > tr > td:lt(3)').remove();
                                }, 500);
                            }
                        })
                        .catch((e) => {
                            document.getElementById("loader").classList.add("hidden");
                            this.$store.state.loader = false;
                            console.log("e", e);
                        });
        },
    },
};
</script>
<style scoped>
.p-datatable-resizable .p-datatable-thead > tr > th .p-column-filter {
  width: 110px  !important;
} 
.p-datatable-resizable .p-datatable-thead > tr > th .p-column-filter input{ 
  width: 130px !important;
}

</style>